import Service, { inject as service } from '@ember/service';

export default class GeneralCommands extends Service {
  @service api;
  @service shData;
  @service store;
  @service('error-tracker') errorTracker;

  /**
   * @returns {*}
   */
  async getNonce() {
    try {
      const response = await this.api.request(`nonce-me`, {});
      this.shData.pushResponseToStore(response);
      return this.store.peekRecord('nonce', response.data.id);
    } catch (e) {
      this.errorTracker.error(e, this, `Failed to fetch a nonce`)
      throw e;
    }
  }
}
